export default class Modal {
    constructor({
        id = null,
        selector = null,
        maximumDisplayTimes = null,
        closeButtonSelector = null,
        excludedAutoCloseSelectors = [],
        // Create
        create = false,
        className = null
    }) {
        if (id.length === 0) {
            throw "Missing id in modal";
        }

        this.id = id;
        this.selector = selector ?? ('#' + this.id);
        this.closeButtonSelector = closeButtonSelector ?? (this.selector + '> .modal-content > .close');
        this.maximumDisplayTimes = maximumDisplayTimes;

        if (true === create) {
            this.create(this.id ?? className);
        }

        this.element = document.querySelector(this.selector);
        this.closeButton = document.querySelector(this.closeButtonSelector);

        this.excludedAutoCloseSelectors = excludedAutoCloseSelectors;

        if (null !== this.element) {
            this.init();
        }
    }
    create (className) {
        if (null !== document.querySelector(this.selector)) {
            return;
        }

        let div = document.createElement('div');
        div.innerHTML = '<div id="'+this.id+'" class="maier-modal '+ className +'"><div class="modal-content"><button class="close">&times;</button><div class="content"></div></div></div>';

        document.querySelector('body').appendChild(div.firstChild);
    }
    init () {
        if (this.element.classList.contains('modal-initialized')) {
            return;
        }

        document.addEventListener('click', (e) => {
            if (
                this.isVisible() &&
                (
                    -1 === e.composedPath().indexOf(this.element) ||
                    -1 === e.composedPath().indexOf(this.element.querySelector('.modal-content'))
                )
            ) {
                for (let excludedAutoCloseSelector of this.excludedAutoCloseSelectors) {
                    if (-1 !== e.composedPath().indexOf(document.querySelector(excludedAutoCloseSelector))) {
                        return;
                    }
                }

                this.hide();
            }
        }, {passive: true})

        if (null !== this.closeButton) {
            this.closeButton.addEventListener('click', (e) => { this.hide(); }, {passive: true});
        }

        this.element.classList.add('modal-initialized');
        this.hide();
    }
    isVisible() {
        return this.element.classList.contains('modal-open');
    }
    show() {
        if (this.maximumDisplayTimes != null && this.getCurrentDisplayTimes() >= this.maximumDisplayTimes) {
            return;
        }

        [document.body, this.element].forEach((element) => {
            element.classList.add('modal-open');
        });

        if (this.maximumDisplayTimes != null) {
            this.setCurrentDisplayTimes(this.getCurrentDisplayTimes() + 1);
        }
    }
    hide() {
        [document.body, this.element].forEach((element) => {
            element.classList.remove('modal-open');
        });
    }
    getDisplayTimesLocalStorageVarName () {
        return 'modal-'+this.id+'-display-times';
    }
    getCurrentDisplayTimes() {
        return parseInt(localStorage.getItem(this.getDisplayTimesLocalStorageVarName()) ?? 0);
    }
    setCurrentDisplayTimes(count) {
        return localStorage.setItem(this.getDisplayTimesLocalStorageVarName(), count);
    }
}
